<template>
	<div>
		<my-navBar></my-navBar>
		<div class="mvInfo">
			<img :src="mvInfo.cover" class="bgBlur">
			<!-- 切换影片列表 -->
			<div class="toggleMvBox" :class="{'showTogMvBox':showToggleMv}">
				<img src="@/assets/img/hideBtn.png" class="hideTogMv" @click="showToggleMv = false">
				<div>
					<toggle-mvSwper :toggleMvList='toggleMvList' @getToggleMv='toggleMv'></toggle-mvSwper>
				</div>
			</div>

			<!-- 影片信息 -->
			<div class="box" :class="{'showToggleMv':showToggleMv}">
				<img src="@/assets/img/toggleMv.png" class="toggleMv" @click="showToggleMv = true">
				<div class="mvName">
					{{mvInfo.name}}
				</div>
				<div class="content">
					<img :src="mvInfo.cover" class="cover" v-if="mvInfo.cover">
					<div class="textItem" v-if='mvInfo.engName'>
						英文名：{{mvInfo.engName}}
					</div>
					<div class="textItem" v-if='mvInfo.label.length>0'>
						类型：{{mvInfo.label}}
					</div>
					<div class="textItem" v-if='mvInfo.length'>
						片长:{{mvInfo.length}}分钟
					</div>
					<div class="textItem" v-if='mvInfo.desc'>
						剧情介绍:{{mvInfo.desc}}
					</div>
					<div v-if='mvInfo.onlineTime' class="onlineTime">上映时间：{{mvInfo.onlineTime}}</div>
					<div class="imgSwiper">
						<img-swiper :imgList='mvInfo.imgList'></img-swiper>
					</div>
				</div>
			</div>
		</div>
		<div class="selTimeArea" v-if="dateList.length>0">
			<div class="topTitle">选座购票</div>
			<div class="filterArea">
				<div class="title">选择时间</div>
				<ul class="right">
					<li class="item" v-for="(dateItem,index) in dateList" :key='dateItem.date' :class="index==dateIndex?'active':''"
					 @click="selDate(index)">
						{{dateItem.date}}
					</li>
				</ul>
			</div>
			<div class="filterArea" v-if="dateList[dateIndex]">
				<div class="title">选择区域</div>
				<ul class="right">
					<li class="item" v-for="(areaItem,index) in dateList[dateIndex].areaList" :key='areaItem.areaName' :class="index==areaIndex?'active':''"
					 @click="selArea(index)">
						{{areaItem.areaName}}
					</li>
				</ul>
			</div>
			<div class="filterArea" v-if="dateList[dateIndex].areaList[areaIndex]">
				<div class="title">选择影院</div>
				<ul :class="['right',{'showAllCine':showAllCine}]">
					<li class="item" v-for="(cineItem,index) in dateList[dateIndex].areaList[areaIndex].cineList" :key='cineItem.cineId'
					 :class="index==cineIndex?'active':''" @click="selCine(index,cineItem)">
						{{cineItem.name}}
					</li>
					<li class="showAllBtn" @click="showAllCine = !showAllCine">{{showAllCine?'收起<<':'查看更多>>'}}</li>
				</ul>
			</div>
		</div>
		<div class="noTimeList" v-if='mvDateList.length==0'>
			<div class="center">
				<img src="@/assets/img/noTime.jpg" class="noTimeIcon">
				<div>没有找到你需要的排期~</div>
			</div>
		</div>
		<div class="timeList" v-if='mvDateList.length>0 && mvDateList.length>0' v-loading='loadingTimeList'>
			<ul class="tableTitle">
				<li>放映时间</li>
				<li>语言版本</li>
				<li>放映厅</li>
				<li>价格</li>
				<li>选座购票</li>
			</ul>
			<ul>
				<li v-for="(timeItem, index) in mvDateList" :key='index' class="timeItem">
					<div class="timeItemTd">
						<div class="center">
							<div class="start">{{timeItem.time}}</div>
							<div class="end">预计{{timeItem.endTime}}散场</div>
						</div>
					</div>
					<div class="timeItemTd">
						<div class="center language">
							{{timeItem.tags}}
						</div>
					</div>
					<div class="timeItemTd">
						<div class="center cineRoom">
							{{timeItem.hall_name}}
						</div>
					</div>
					<div class="timeItemTd">
						<div class="center">
							<div class="priceLine">
								<span>¥{{timeItem.show_price}}起</span>
							</div>
						</div>
					</div>
					<div class="timeItemTd">
						<div class="center selTime" @click="toSelSeat(timeItem)">选座购票</div>
					</div>
				</li>
			</ul>
		</div>

		<my-footer></my-footer>
	</div>
</template>

<script>
	import imgSwiper from '@/components/mySwiper.vue'
	import toggleSw from '@/components/toggleMvSw.vue'
	export default {
		name: 'mvInfo',
		data() {
			return {
				showToggleMv: false,
				mvInfo: {
					label: [],
					imgList: [],
				},
				dateIndex: '0',
				dateList: [],
				areaIndex: 0,
				cineIndex: 0,
				showAllCine: false, //展开所有影院列表
				mvDateList:[],//场次列表数组
				toggleMvList: [], //切换影片列表
				loadingTimeList:false
			}
		},
		components: {
			'img-swiper': imgSwiper,
			'toggle-mvSwper': toggleSw
		},
		methods: {
			resetPage: function() {
				this.showToggleMv = false;
				this.mvInfo.label = [];
				this.mvInfo.imgList = [];
				this.dateIndex = 0;
				this.dateList = [];
				this.areaIndex = 0;
				this.cineIndex = 0;
				this.showAllCine = false;
				this.mvDateList = [];
			},
			toggleMv: function(index) {
				this.$route.query.show_id = this.toggleMvList[index].id;
				this.resetPage();
				this.$nextTick(()=>{
					this.getMvInfo(this.toggleMvList[index].id);
					//获取影院列表-->获取排片列表
					this.axiosCineList()
				})
			},
			selDate: function(index) {
				this.mvDateList = [];
				this.dateIndex = index;
				this.areaIndex = 0;
				this.cineIndex = 0;
				this.$nextTick(()=>{
					this.axiosCineList()
				})
			},
			selArea:function(index){
				this.mvDateList = [];
				this.areaIndex = index;
				this.cineIndex = 0;
				
				//获取该区域的第一家电影院的场次列表
				this.getMvListTimeList(this.dateList[this.dateIndex].areaList[index].cineList[0].cineId)
			},
			selCine: function(index,cineItem){
				this.mvDateList = [];
				this.cineIndex = index;
				this.getMvListTimeList(cineItem.cineId)
			},
			toSelSeat: function(item) { 
				var curCineItem = this.dateList[this.dateIndex].areaList[this.areaIndex].cineList[this.cineIndex];
				this.$store.commit('updateCineInfo',{
					id: curCineItem.cineId,
					name: curCineItem.name,
					hall_name: item.hall_name,
					addr: curCineItem.addr,
					tel: curCineItem.phone
				})
				
				this.$router.push({
					path: '/selSeat',
					query: {
						mvInfo:JSON.stringify({
							name:this.mvInfo.name,
							label: this.mvInfo.label,
							length: this.mvInfo.length,
							cover: this.mvInfo.cover
						}),
						price: item.show_price,
						schedule_area: item.schedule_area,
						schedule_id: item.schedule_id,
            plan_key: item.plan_key,
            commonPrice: item.commonPrice,
            artificial_buy_price: item.artificial_buy_price,
            film_code: item.film_code,
						timeInfo:JSON.stringify({
							date: this.dateList[this.dateIndex].date,
							startHM: item.time,
							endHM: item.endTime
						})
					}
				})
			},
			getMvInfo: function(show_id = '') {
				var that = this;
				that.axios.post('/resUrlTB/api/v2/getFilmDetail', {
						group_id: that.$store.state.group_id,
						film_id: show_id
					})
					.then(function(res) {
						if (res.data.code == 0) {
							var resMv = res.data.content.film;
							that.mvInfo.cover = resMv.trailer_cover;
							that.mvInfo.desc = resMv.introduction;
							that.engName = resMv.show_name_en;
							that.mvInfo.engName = resMv.show_name_en;
							var imgList = [];
							var resImg = resMv.still;
							if (resImg) {
								for (var i = 0; i < resImg.length; i++) {
									if (!resImg[i]) {
										continue;
									}
									imgList.push(resImg[i]);
								}
							}
							that.mvInfo.imgList = imgList;
							that.mvInfo.label = resMv.type;
							that.mvInfo.length = resMv.duration;
							that.mvInfo.name = resMv.film_name;
							that.mvInfo.onlineTime = that.global.getTime(resMv.start_time);
						}
					})
			},
			axiosTogMvList: function() {
				var that = this;
				//正在热映
				that.axios.post('/resUrlTB/api/v2/getHotFilms', {
						group_id: that.$store.state.group_id,
						city_name: that.$store.state.selCityInfo.region_name
					})
					.then(function(res) {
						if (res.data.code == 0) {
							var resHot_films = res.data.content.hot_films;
							var arr = [];
							for (var i = 0; i < resHot_films.length; i++) {
								if (arr.length == 15) {
									break;
								}
								var item = {
                  cover: resHot_films[i].trailer_cover,
									id: resHot_films[i].id,
									name: resHot_films[i].film_name
								}
								arr.push(item);
							}
							that.toggleMvList = arr;
						}
					})
			},
			compPhoneNum: function(strPhone) {
				var phone = '';
				if (strPhone) {
					phone = strPhone.split(' ')[0];
				}
				return phone;
			},
			axiosCineList: function() {
				var that = this;
				//影院列表
				var reqData = {
					film_id: that.$route.query.show_id,
					group_id: that.$store.state.group_id,
					city_name: that.$store.state.selCityInfo.region_name,
					lat: that.$store.state.lat,
					lng: that.$store.state.lng
				};
				if (that.dateList[that.dateIndex]) {
					reqData.date = that.dateList[that.dateIndex].show_date;
				}


				that.axios.post('/resUrlTB/api/v2/getFilmCinemas', reqData)
					.then(function(res) {
						if (res.data.code == 0) {
							var resDateList = res.data.content.film_dates;
							if (resDateList.length == 0) {
								that.$confirm('暂无排期', '提示', {
									showCancelButton: false,
									type: 'warning'
								})
							}
							var resList = res.data.content.film_cinemas;
							var data_newDateList = that.dateList;
							
							var newDateList = data_newDateList.length == 0 ? [] : data_newDateList;

							/*---日期列表和影院列表2个数组分开渲染 ---*/

							/*--日期列表--*/
							if (data_newDateList.length == 0) {
								for (var d = 0; d < resDateList.length; d++) {
									//转时间戳
									var strResDate = resDateList[d];
									strResDate = strResDate.replace(/-/g, "/");
									var timeStamp = Math.round(new Date(strResDate).getTime() / 1000);
									//今天明天后天周几？
									var saveDate = that.global.getTime(timeStamp, false, false, false, false, false,
										true);
									var saveTimeStamp = that.global.getDayBegin(timeStamp);
									var weekDay = that.global.getWeekDay(timeStamp);
									var dateItem = {
										date: saveDate,
										saveTimeStamp,
										show_date: resDateList[d],
										weekDay: weekDay,
										areaList: [],
									}
									newDateList.push(dateItem);
								}
							}


							/*--影院列表--*/
							for (var i = 0; i < resList.length; i++) {
								//渲染列表
								var noSameArea = true;
								var cineItem = {
                  cineId: resList[i].cinema_id,
                  name: resList[i].cinema_name,
                  addr: resList[i].address,
                  distance: resList[i].distance,
                  phone: that.compPhoneNum(resList[i].phone),
                  lat: resList[i].latitude,
                  lng: resList[i].longitude,
                  price: Number(resList[i].price).toFixed(2),
                  timeListStr: ''
								}
								//每家影院显示的场次时间列表字符串
								var cineItemSchedules = resList[i].plans;
								for (var s = 0; s < cineItemSchedules.length; s++) {
									cineItem.timeListStr += `${cineItemSchedules[s].show_time} | `;
								}
								if (cineItem.timeListStr) {
									cineItem.timeListStr = cineItem.timeListStr.substring(0, cineItem.timeListStr
										.length - 3);
								}

								for (var a = 0; a < newDateList[that.dateIndex].areaList.length; a++) {
									if (newDateList[that.dateIndex].areaList[a].areaName == resList[i].county) {
										var noSameCine = true;
										for (var c = 0; c < newDateList[that.dateIndex].areaList[a].cineList
											.length; c++) {
											if (resList[i].cinema_id == newDateList[that.dateIndex].areaList[a]
												.cineList[c].cineId) {
												noSameCine = false;
												break;
											}
										}
										if (noSameCine) {
											newDateList[that.dateIndex].areaList[a].cineList.push(cineItem)
										}
										noSameArea = false;
										break;
									}
								}
								if (noSameArea) {
									var areaItem = {
										areaName: resList[i].county,
										cineList: []
									}
									areaItem.cineList.push(cineItem);
									newDateList[that.dateIndex].areaList.push(areaItem);
								}
							}
							that.dateList = newDateList;
							var firstCine = newDateList[that.dateIndex].areaList[0].cineList[0];
							//获取第一家影院的场次列表
							that.getMvListTimeList(firstCine.cineId);
						}
					})
			},
			getMvListTimeList: function(cineId) {
        console.log("1111");
				//获取场次列表
				var that = this;
				that.loadingTimeList = true;
				
				that.axios.post('/resUrlTB/api/v2/getPlans', {
						cinema_id: cineId,
						film_id: that.$route.query.show_id,
						city_name: that.$store.state.selCityInfo.region_name,
						group_id: that.$store.state.group_id
					})
					.then(function(res) {
						if (res.data.code == 0) {
							//渲染场次列表
							var resTimeList = res.data.content.plans;
							var mvDateList = [];
							//判断今天明天后天
							var newDate = new Date();
							var pkMonth = Number(newDate.getMonth() + 1);
							var pkDate = Number(newDate.getDate());
							for (var t = 0; t < resTimeList.length; t++) {
								var startHoursMinutes = that.global.getTime(resTimeList[t].start_time, false, false, true);
								var endHoursMinutes = that.global.getTime(resTimeList[t].end_time, false, false, true);
								var timeItem = {
                  schedule_id: resTimeList[t].cinema_id,
                  start_timeStamp: resTimeList[t].start_time,
                  plan_key: resTimeList[t].plan_key,
                  film_code: resTimeList[t].film_code,
                  time: startHoursMinutes,
                  endTime: endHoursMinutes,
                  tags: resTimeList[t].copy_type, 
                  hall_name: resTimeList[t].hall_name,
                  isAreaPrice: resTimeList[t].sit_area.length && resTimeList[t].sit_area.some(item => item.diffPrice > 0), 
                  show_price:  resTimeList[t].artificial_buy_price > 0 && (resTimeList[t].artificial_buy_price < resTimeList[t].price || resTimeList[t].price == 0) ? resTimeList[t].artificial_buy_price :  resTimeList[t].price,
                  artificial_buy_price: resTimeList[t].artificial_buy_price,//特惠价
                  commonPrice: resTimeList[t].price, //普通价
                  schedule_area: resTimeList[t].sit_area,
                  btnText:'选座'
								}
								if (that.global.getTime(resTimeList[t].start_time) == that.dateList[that.dateIndex].show_date) {
									mvDateList.push(timeItem)
								}
							}
							that.mvDateList = mvDateList;
							that.$nextTick(()=>{
								setTimeout(()=>{
									that.loadingTimeList = false;	
								},300)
							})
						}
					})
					.catch(function(res){
						that.loadingTimeList = false;
					})
			}

		},
		created: function() {
			// 获取切换影片列表
			this.axiosTogMvList();
			//获取影片信息
			this.getMvInfo(this.$route.query.show_id)
			//获取影院列表-->获取排片列表
			this.axiosCineList()
		},
	}
</script>

<style scoped src='@/assets/css/mvInfo.css'>
</style>
